'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styleInject = require('style-inject');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styleInject__default = /*#__PURE__*/_interopDefaultLegacy(styleInject);

var css_248z = ".Paragraph-module_paragraph__a9aT5{color:#666;font-family:inherit;font-size:.875rem;font-weight:400;line-height:1;margin:.75rem 0}";
var styles = {"paragraph":"Paragraph-module_paragraph__a9aT5"};
styleInject__default["default"](css_248z);

exports["default"] = styles;
